import React, { useState } from "react";
import { Modal, Box, Typography, TextField, IconButton, Divider } from "@mui/material";
import { Circle } from "@mui/icons-material";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import { ReactComponent as CrossIcon } from "../../assets/images/crossIconAdvancedFilter.svg";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as Colorplate } from "../../assets/images/ColorPlate.svg";

const modalStyle = {
  width: 500,
  maxWidth: "90vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 0,
};

const AddFolderModal = ({
  showAddFolderModal,
  handleDialogClose,
  folderName,
  handleFolderNameChange,
  colorOptions,
  folderColor,
  handleColorSelect,
  handleSubmit,
}) => {
  const isSaveDisabled = folderName.trim().length === 0;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!isSaveDisabled) await handleSubmit();
    setIsSubmitting(false);
  };

  return (
    <Modal
      open={showAddFolderModal}
      onClose={handleDialogClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(1px)",
      }}
    >
      <Box sx={modalStyle}>
        <form onSubmit={onFormSubmit}>
          <div className="flex justify-between items-center p-4 pt">
            <p>Add Folder</p>
            <IconButton onClick={handleDialogClose}>
              <CrossIcon />
            </IconButton>
          </div>
          <Divider />

          <div className="p-3">
            <Typography variant="body2" color="text.secondary">
              Folder Name{" "}
              <ToolTipComponent text="Max 20 character limit allowed">
                <Typography component="span" color="error" sx={{ cursor: "pointer" }}>
                  *
                </Typography>
              </ToolTipComponent>
            </Typography>

            <TextField
              fullWidth
              size="small"
              value={folderName}
              onChange={handleFolderNameChange}
              inputProps={{ maxLength: 20 }}
              autoFocus
            />

            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Folder Color
            </Typography>

            {/* Color Selection Row */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
              <Box sx={{ display: "flex", gap: 1 }}>
                {colorOptions.map((color) => (
                  <IconButton
                    key={color}
                    onClick={() => handleColorSelect(color)}
                    sx={{
                      p: 0.5,
                      border: folderColor === color ? "2px solid #1D4469" : "2px solid transparent",
                    }}
                  >
                    <Circle sx={{ color }} />
                  </IconButton>
                ))}
              </Box>

              <Box sx={{ flexGrow: 1 }} />

              {/* <Colorplate /> */}
            </Box>

            {/* Dashed divider between color section and selected color */}
            <Divider
              sx={{
                borderStyle: "dashed",
                borderColor: "#C5C5C5",
                my: 2,
              }}
            />

            {/* Show selected color on the right side */}
            {folderColor && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mb: 2,
                  pr: 1,
                }}
              >
                <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                  Selected Color:
                </Typography>
                <Circle sx={{ color: folderColor, fontSize: 24 }} />
              </Box>
            )}

            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <Button onClick={handleDialogClose} variant="secondary">
                Cancel
              </Button>
              <Button type="submit" isDisabled={isSaveDisabled || isSubmitting} className="px-4 py-2 rounded-lg">
                {isSubmitting ? "Saving" : "Save"}
              </Button>
            </Box>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default AddFolderModal;
